import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { PurposeCreationIntent } from '../../../../graphql/schema';
import { NameAndImage } from '../../NameAndImage';
import { nameAndImage } from '../../sharedSchemas';
import { useEmergencyFundStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof nameAndImage>;

export const EmergencyFundNameAndImageStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();

  const { commit } = useEmergencyFundStep('nameAndImage');

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/emergency_fund/${flowId}/monthly_expenses`);
  };

  return <NameAndImage handleSubmit={handleSubmit} intent={PurposeCreationIntent.EmergencyFund} />;
};
